import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const InfoBanner = ({isBulkMode}) => (
    <div className="flex flex-col gap-1 mx-4 mb-1">
        <div className="flex items-start gap-2 p-2.5 rounded-menu text-xs text-main-normal" style={{backgroundColor: 'color-mix(in srgb, var(--classicbutton-normal-color) 10%, transparent)'}}>
            <InfoOutlinedIcon style={{fontSize: 16, color: 'var(--classicbutton-normal-color)', marginTop: 1}} />
            <span>Public projects are accessible workspace-wide. Folders/items marked as public are visible to all project members. Group access is automatically inherited.</span>
        </div>
        {isBulkMode && (
            <div className="flex items-start gap-2 p-2.5 rounded-menu text-xs text-main-normal" style={{backgroundColor: 'color-mix(in srgb, var(--caution-warning-color) 10%, transparent)'}}>
                <WarningAmberIcon style={{fontSize: 16, color: 'var(--caution-warning-color)', marginTop: 1}} />
                <span>Some items have conflicted access across the selected members.</span>
            </div>
        )}
    </div>
);

export default InfoBanner;
